import { render } from "./IncreasePettyCashBalance.vue?vue&type=template&id=6d2ae5c0"
import script from "./IncreasePettyCashBalance.vue?vue&type=script&lang=js"
export * from "./IncreasePettyCashBalance.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__